import mapImage from '../../assets/textures/map.png'
import styles from './InteractiveMapStyles.module.scss'
import CloseButton from "../CloseButton";

function InteractiveMap({mapIsShown, points, handleTransitionClick, onClose, currentSceneId}) {
    return (<div className={`${styles.mapOverlay} ${mapIsShown ? styles.visible : ''}`}>
        <div className={styles.mapContainer}>
            <CloseButton onClick={onClose} style={{top: '6px', right: '6px'}}/>
            <img src={mapImage} alt="Карта" className={styles.mapImage} />
            {points.map((point) => (
                <div
                    key={point.id}
                    className={`${styles.mapPoint} ${currentSceneId === point.id ? styles.disabled : ''}`}
                    style={{
                        top: `${point.coords.y}%`,
                        left: `${point.coords.x}%`,
                    }}
                    onClick={() => handleTransitionClick(point.id)}
                    title={`${point.name}`}
                >
                    {currentSceneId !== point.id && <span className={styles.mapPointPulse}></span>}
                </div>
            ))}
        </div>
    </div>);
}

export default InteractiveMap;